import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import CDPBreadCrumb from "./component";
import { reloadCarList } from "../car-listing/actions";

const mapStateToProps = ({
    carDetails: { content },
    filters: {
        appliedFilters
    }

}) => {
    const { year, make, model, city, transmissionType, variant } = content || {};
    const carName = `${year || ""} ${make || ""} ${model || ""} ${variant || ""} ${transmissionType || ""}`;
    return {
        make,
        carName,
        appliedFilters,
        city,
        model
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    reloadCarListConnect: reloadCarList
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CDPBreadCrumb));
